<template>
<div class="followers-card">
    <div class="flex query-header">
        <div class="flex query-header-text">
            <p>My Followers</p>
        </div>
        
        <div class="flex">
            <v-menu
                v-model="showMenudialog"
                :close-on-content-click="false" 
                :offset-x="false" 
                right 
                :offset-y="true" 
                :nudge-bottom="20"
                content-class="elevation-0"
            >
                <template v-slot:activator="{ on, attrs }">
                    <button @click="handleAddBtnClick" v-bind="attrs" v-on="on" class="query-header-btn flex" >       
                        <v-icon size="20" class="icon"> mdi-plus</v-icon> <v-spacer/>Add Filters
                    </button>
                </template>

                <div v-if="showfilter">
                    <filters @applyfilter="handlefilterclick" @closefilter="closeaddFilter"/>  
                </div>

            </v-menu>
            <v-icon @click="handleClose" size="20" class="close-icon"> mdi-close-thick</v-icon> 
        </div>
    </div>

    <div class="list flex my-2" v-for="follower in followersdata" :key="follower.id">
        <farmer-card :followedata = "follower"/>
    </div> 
    <div class="emptyspace"></div>
    <v-progress-linear
		indeterminate
        height="4"
		class="mt-1 loader"
		color="#1F8F58"
		v-if="isdatapresent"
	></v-progress-linear>
    <div v-show="!isdatapresent" class="paginaton_con">
        <pagination  :total="totalCount" ref="paginationFollowerRef" :perPage="30" @changePage="reloadFollowerAPI()"/>
    </div>
    <br>
</div>
</template>


<script>
import farmerCard from './farmer-card.vue'
import farmerDetails from './farmer-details.vue'
import filters from './filters.vue'
import API_URL from "../../../../helpers/apiUrls"
import { mapActions } from "vuex";
import accessToken from "../../../../helpers/accessToken";
import pagination from '../../Common/pagination.vue';

export default {
    ...mapActions("StateFilterStore", ['addstatedata','GET_STATE_ID']),
    name : 'followerlist',

    data(){
        return{
            isActive : true, 
            showMenudialog : this.showMenu,
            showfilter : false,
            followersdata: [],
            business_id : '',
            // business_id : '8e803872-47a9-46fc-b8d6-4e98a2f5dd4b',
            storedata: [],
            filterkey:false,
            temp1: true,
            stateparams: "",
            storeStateId:[],
            isfilterclicked: false,
            followercount: 0,
            applyfilterclicked: false,
            isdatapresent: false,
            page: 1,
            totalCount: 0,
            bool: true,
        }
    },
    watch:{
        followersdata: function(){
            this.$emit('followercount', this.totalCount)
            if(!this.isfilterclicked){
                this.timer()
            }
        },
    },
    mounted(){
        console.log("FOLLOWER LIST MOUNTED");
        console.log("SHOWMENU", this.showMenu);
        this.business_id = accessToken.getCredentials().brandID;
        this.reloadFollowerAPI();
    },

    methods :{
        handleClose(){
            this.$emit('close');       
            this.showfilter = true
        },
        handleAddBtnClick(){
            console.log("HANDLE ADD CLCK");
            this.showMenudialog = true;
            this.showfilter = true;
        },
        closeaddFilter(){
            console.log("IN CLOSE FILTER");
            this.$emit('filtercliked');
            this.showMenudialog = false;
            this.showfilter = !this.showfilter;
            this.isfilterclicked = true;
            this.stateparams = ""
            this.getFollowerslist();
            this.bool = true;
        },
        handlefilterclick(){
            this.$emit('filtercliked');
            this.showMenudialog = false;
            this.applyfilterclicked = true,
            this.showfilter = false;
            console.log(this.$store.getters['StateFilterStore/GET_STATE_ID'][0]);
            this.reloadFollowerAPI();
        },

        reloadFollowerAPI(){
            this.isdatapresent = true;
            if(!this.applyfilterclicked){
                this.timer()
            }
            this.isfilterclicked = true;
            this.stateparams = "";
            this.storedata = this.$store.getters['StateFilterStore/GET_STATE_ID'];
            console.log("STOREDATA", this.storedata);
            if(this.storedata.length !==0 && this.storedata.length !== 0){
                for(var i = 0; i<this.storedata.length-1; i++){
                        this.stateparams += "&states="
                        this.stateparams += this.storedata[i]

                }
                if(this.applyfilterclicked && this.bool){
                    this.$refs.paginationFollowerRef.page = 1;
                    this.bool = false;
                }
                this.stateparams += "&states="
                this.stateparams += this.storedata[this.storedata.length-1]
                console.log(this.stateparams);
                this.getFollowerslist();
            } else {
                this.getFollowerslist();
            }
        },
        getStoredata(){
            console.log(this.$store.getters['StateFilterStore/GET_STATE_ID'])
            this.storeStateId = this.$store.getters['StateFilterStore/GET_STATE_ID'];   
        },

        timer(){
            setTimeout(() => {
                this.showfilter = true
            }, "400")
        },

        getFollowerslist(){
            this.isdatapresent = true;
            // this.toggleLoader(true);
            const successHandler = (response) => {
                // this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("RES ___  ", response.data.data);
                    this.followersdata = response.data.data;
                    this.totalCount = response.data.total_count;
                    this.isdatapresent = false;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.isdatapresent = false;

                // this.toggleLoader(false);
            };

            this.requestGET(
                `${API_URL.myfarmer_followers}?business_id=${this.business_id}&page=${this.$refs.paginationFollowerRef.page}&data_per_page=${30}${this.stateparams}`,
                {},
                {},
                successHandler,
                errorHandler,
                
            );
        },
    },
    components : {
        'farmer-card' : farmerCard,
        'filters' : filters,
        'farmer-details' : farmerDetails,
        'pagination' : pagination,
    },
    props: {
        showMenu: Boolean,   
    }
}
</script>


<style lang="scss" scoped>
.query-header{
    justify-content: space-between;
    padding: 20px 20px 20px 25px;
}
.followers-card{
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
}
.query-header-text{
    justify-content: flex-start;
}
.list{
    margin-top: 10px;
}
.emptyspace{
    height: 30px;
    width: 100%;
}
.query-header-text p{
    cursor: pointer;
    margin: 0px 20px 0px 0px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #000000;
    text-decoration: underline;
    text-underline-offset: 12px;
    text-decoration-thickness: 2.5px;
    text-decoration-color: #1D8D56;
}
.query-header-btn{
    background-color: #EBF5F0;
    color: #1D8D56;
    font-size: .9rem;
    font-weight: 500;
    padding: 10px 14px;
    border-radius: 3px;
}
.farmer-details{
    justify-content: flex-start;
    padding: 10px 25px;
    p{
        margin-bottom: 0px;
    }
}
.farmer-name{
    justify-content: flex-start;
    align-items: center;
    width: 30%;
}
.farmer-avatar{
    margin-right: 10px;
}
.date{
    width: 20%;
}
.acre{
    width: 15%;
}
.close-icon{
    background-color: #F5EBEB;
    color: #DA5A5A;
    width: 34px;
    padding: 11px 0px;
    border-radius: 3px;
    margin-left: 10px;
    cursor: pointer;
}
.loader{
    position: absolute;
    bottom: 5px;
    // top: 100%;
    width: 39.3%;
}
.paginaton_con{
    position: absolute;
    bottom: 0px;
    margin: 0px auto;
    width: 39.45%;
    background-color: #FFFFFF;
    padding: 8px 0px;
}
</style>